import { IMetaData } from '../interfaces/meta-data.interface';

/**
 * SEO Meta tags configuration for each route
 * Uses translation keys that will be resolved by MetasService
 */
export const SEO_META_TAGS: Record<string, IMetaData> = {
  home: {
    title: 'SEO.HOME.TITLE',
    description: 'SEO.HOME.DESCRIPTION',
    keywords: 'SEO.HOME.KEYWORDS',
    url: '/home',
    image: '/images/smiling-woman-holding-afro-picks.webp',
    type: 'website'
  },
  hairdressers: {
    title: 'SEO.HAIRDRESSERS.TITLE',
    description: 'SEO.HAIRDRESSERS.DESCRIPTION',
    keywords: 'SEO.HAIRDRESSERS.KEYWORDS',
    url: '/hairdressers',
    image: '/images/og-hairdressers.webp',
    type: 'website'
  },
  hairstyles: {
    title: 'SEO.HAIRSTYLES.TITLE',
    description: 'SEO.HAIRSTYLES.DESCRIPTION',
    keywords: 'SEO.HAIRSTYLES.KEYWORDS',
    url: '/hairstyles',
    image: '/images/og-hairstyles.webp',
    type: 'website'
  },
  auth: {
    title: 'SEO.AUTH.TITLE',
    description: 'SEO.AUTH.DESCRIPTION',
    keywords: 'SEO.AUTH.KEYWORDS',
    url: '/auth',
    image: '/images/og-auth.webp',
    type: 'website'
  },
  terms: {
    title: 'SEO.TERMS.TITLE',
    description: 'SEO.TERMS.DESCRIPTION',
    keywords: 'SEO.TERMS.KEYWORDS',
    url: '/terms',
    image: '/images/og-terms.jpg',
    type: 'website'
  },
  privacy: {
    title: 'SEO.PRIVACY.TITLE',
    description: 'SEO.PRIVACY.DESCRIPTION',
    keywords: 'SEO.PRIVACY.KEYWORDS',
    url: '/privacy',
    image: '/images/og-privacy.jpg',
    type: 'website'
  },
  reviews: {
    title: 'SEO.REVIEWS.TITLE',
    description: 'SEO.REVIEWS.DESCRIPTION',
    keywords: 'SEO.REVIEWS.KEYWORDS',
    url: '/reviews',
    image: '/images/og-reviews.jpg',
    type: 'website'
  }
};

/**
 * Get SEO meta data for a specific route
 * @param routeName - Name of the route (key in SEO_META_TAGS)
 * @param customData - Optional custom data to override defaults
 */
export function getSEOMetaData(routeName: string, customData?: Partial<IMetaData>): IMetaData | null {
  const baseData = SEO_META_TAGS[routeName];
  if (!baseData) {
    return null;
  }

  return customData ? { ...baseData, ...customData } : baseData;
}

